module.exports = __webpack_public_path__ + "img/Dienstleistungen_Transport2.0a8bf17.jpg";